import React from 'react';
import PropTypes from 'prop-types';
import MuiStepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepConnector from '@material-ui/core/StepConnector';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  stepperRoot: {
    padding: theme.spacing(1),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(2, 1),
    },
    backgroundColor: theme.palette.blue.lighter,
  },
  connectorActive: {
    '& $connectorLine': {
      borderColor: theme.palette.primary.main,
    },
  },
  connectorCompleted: {
    '& $connectorLine': {
      borderColor: theme.palette.primary.main,
    },
  },
  connectorDisabled: {
    '& $connectorLine': {
      borderColor: theme.palette.blue.light,
    },
  },
  connectorLine: {
    color: theme.transitions.create('border-color'),
  },
  label: {
    fontFamily: 'Rubik',
    color: theme.palette.grey.darker,
    lineHeight: 1.2,
    fontSize: 12,
    marginTop: `${theme.spacing(1)}px !important`,
    [theme.breakpoints.down('xs')]: {
      marginTop: `${theme.spacing(0.5)}px !important`,
    },
  },
  labelActive: {
    fontWeight: 500,
    color: `${theme.palette.primary.main} !important`,
  },
  labelCompleted: {
    color: `${theme.palette.primary.main} !important`,
  },
  stepIcon: {
    color: theme.palette.primary.contrastText,
    border: `0.5px solid ${theme.palette.grey.main}`,
    borderRadius: '50%',
    '& text': {
      fill: `${theme.palette.grey.darker} !important`,
    },
  },
  iconActive: {
    color: `${theme.palette.secondary.light} !important`,
    border: `0.5px solid ${theme.palette.secondary.main}`,
    '& text': {
      fill: `${theme.palette.primary.dark} !important`,
      fontWeight: 500,
    },
  },
  iconCompleted: {
    color: `${theme.palette.primary.main} !important`,
  },
}));

const Stepper = ({ activeStepIndex, steps }) => {
  const classes = useStyles();

  const currentStep = steps[activeStepIndex];
  if (!currentStep.label) {
    return null;
  }

  return (
    <MuiStepper
      classes={{
        root: classes.stepperRoot,
      }}
      alternativeLabel
      activeStep={activeStepIndex}
      connector={
        <StepConnector
          classes={{
            active: classes.connectorActive,
            completed: classes.connectorCompleted,
            disabled: classes.connectorDisabled,
            line: classes.connectorLine,
          }}
        />
      }
    >
      {steps
        .filter((step) => !step.subStepOf && step.label)
        .map((step) => (
          <Step
            key={step.label}
            classes={{
              root: classes.stepRoot,
            }}
          >
            <StepLabel
              classes={{
                active: classes.labelActive,
                completed: classes.labelCompleted,
                label: classes.label,
              }}
              StepIconProps={{
                classes: {
                  root: classes.stepIcon,
                  active: classes.iconActive,
                  completed: classes.iconCompleted,
                },
              }}
            >
              {step.label}
            </StepLabel>
          </Step>
        ))}
    </MuiStepper>
  );
};

Stepper.propTypes = {
  activeStepIndex: PropTypes.number.isRequired,
  steps: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default Stepper;
